import { CharacterizationInstrumentDto } from '@/api/ApiClient';

/**
 * Instruments available for an internal (non-External) characterization facility.
 * Always retains the activity's current instrument so existing rows stay selectable in the dropdown.
 */
export function getCharacterizationInstrumentsForFacility(
  instruments: readonly CharacterizationInstrumentDto[],
  facility: string | undefined | null,
  currentInstrumentId?: string | null
): CharacterizationInstrumentDto[] {
  if (!facility || facility === 'External') {
    return [];
  }

  const filtered = instruments.filter((inst) => inst.facility === facility);

  if (!currentInstrumentId) {
    return filtered;
  }

  const current = instruments.find((inst) => inst.id === currentInstrumentId);
  if (current && !filtered.some((inst) => inst.id === current.id)) {
    return [current, ...filtered];
  }

  return filtered;
}

export function formatCharacterizationInstrumentLabel(inst: CharacterizationInstrumentDto): string {
  return `${inst.id ?? ''} - ${inst.name ?? 'Unknown Instrument'}`;
}
